export default __webpack_public_path__ + "static/media/dark.7ece7e17.png";